import { useSwipeBack } from '../lib/useSwipeBack'

export default function FlowScreenContainer({ onBack, children, className = 'animate-fade-in' }) {
  const enabled = Boolean(onBack)
  const swipeHandlers = useSwipeBack(onBack, enabled)

  return (
    <div
      className={`tma-flow-container relative flex min-h-0 w-full flex-1 flex-col overflow-hidden ${className}`}
      {...swipeHandlers}
      style={enabled ? { touchAction: 'pan-y', overscrollBehavior: 'none' } : undefined}
    >
      {children}
    </div>
  )
}
